module.exports = __webpack_public_path__ + "static/img/t1-5-4.79d2dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-5-4.png
// module id = D2GG
// module chunks = 1